import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBraunschweig() {
  return (
    <CityPageTemplate
      city="Braunschweig"
      slug="braunschweig"
      intro="Braunschweig als Wissenschafts- und Technologiestadt – Deine Finanzplanung sollte genauso innovativ sein."
      description="Unabhängige & digitale Finanzberatung für Braunschweig: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
